import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCausesCondictionsChartsDataContext } from './hooks/useCausesCondictionsChartsDataContext';

export const MedicalAssistance = () => {
    const { chartData } = useCausesCondictionsChartsDataContext();

    return (
        <SimpleBars
            title={'Assistência Médica'}
            horizontal={true}
            subtitles={chartData?.medicalAssistance?.map(
                (item) => item.description
            )}
            values={chartData?.medicalAssistance?.map(
                (item) => item.total || 0
            )}
            className="aligned-container"
        />
    );
};
